(function (root, factory) {
    if (typeof define === 'function' && define.amd) {
        // AMD. Register as an anonymous module.
        define([
            'abstract-storage/abstract-storage'
        ], factory);
    } else if (typeof module === 'object' && module.exports) {
        // CommonJS
        module.exports = factory(
            require('abstract-storage/abstract-storage')
        );
    }
})(this, function(manager){

    var errorCodes = manager.errorCodes;

    var UNDEF;

    var getEmpty = manager.getEmpty;
	/**
	 * Internal cache for StorageEntry instances.
	 * It puts the "Mem" in MemStorage!
	 * @type {Object}
	 * @example : 
	 * {
	 * 		"namespace" : {
	 * 			"key" 	: {object StorageEntry}
	 * 			"key2"	: {object StorageEntry}
	 * 		},
	 * 		"namespace2": {
	 * 			"key2"	: {object StorageEntry}
	 * 		} 
	 * }
	 * @see manger.StorageEntry
	 */
	var items ={};

    function storageCleanup(that, namespace) {
        var nso=that.getAll(namespace);
        var key;
        var item;
        for(key in nso){
            item=nso[key];
            if(item.expired===1){
                delete items[namespace][key];
            }else{
                // remove from the return object
                delete nso[key];
            }
        }
        return nso;
    }

    function getAllFromNamespace(namespace){
        var key;
        var ret = {};
        var nso = items[namespace];
        if(nso){
            for(key in nso){
                ret[key]=manager.get(nso[key]);
            }
        }
        return ret;
    }

	return {
        StorageEntry : manager.StorageEntry,
        /**
         * Place an exiting StorageEntry instance in the cache. 
         * 
         * @param  {object} storageEntry An instance of StorageEntry.
         * @return {boolean}            Returns true if storageEntry was successfully adopted.
         */
        adopt:function(storageEntry) {
            if(!(storageEntry instanceof manager.StorageEntry) ){
                return false;
            }
            var namespace = storageEntry.namespace;
            var key = storageEntry.key;
            var stored;
            if(manager.validKeys(namespace, key)){
                if(!items[namespace]){
                    items[namespace]={};
                } 
                stored = items[namespace][key] = manager.get(storageEntry);
                return stored.created !== 0 && !stored.error;
            }
            return false;
        },
		/**
		 * Create a new StorageEntry instance and place it in the 
		 * cache. @see items for example.
		 * 
		 * @param  {string} namespace Top-level container for object grouping.
		 * @param  {string} key       Primary storage key for individial objects.
		 * @param  {mixed} 	value     Data to be stored.
		 * @param  {number} expires   Time in seconds
		 * @return {object}           Returns a valid StorageEntry instance.
		 */
	    put : function(namespace, key, value, expires) {
            if(manager.validKeys(namespace, key)){
    	        return (items[namespace] = items[namespace]||{})[key] = manager.storable(namespace,key,value,expires);
            }
            return getEmpty(errorCodes.INVALID_KEY);
	    },
        /**
         * Attempt to retrieve all items in the cache form the given namespace.
         * 
         * @param  {string} namespace   Namespace to retrieve.
         * @return {object}             Collection of retrieved items or empty object.
         */
        getAll: function(namespace) {
            var key;
            var ret = {};
            if(namespace !== UNDEF){
                return getAllFromNamespace(namespace);
            }else {
                for (key in items){
                    ret[key] = getAllFromNamespace(key);
                }
            }
        	return ret;
        },
        /**
         * Attempt to retrieve a storage object from the localStoage cache items.
         * If expired as dicated by the created and expires properties,
         * the object will be marked accordingly via the expired property.
         * (If none exists, return an empty expired object)
         * 
         * @param {string} namespace Namespace of object to retrieve.
         * @param {string} key      Key of object to retrieve from the given namespace.
         * @uses   getWithFullKey
         * @return {object}     Object so or an "empty" storage object.
         */        
	    get: function(namespace, key) {
            if(manager.validKeys(namespace, key)){
    	        var item = items[namespace] && items[namespace][key];

    	        return manager.get(item); 
            }
            return getEmpty(errorCodes.INVALID_KEY);
	    },
        /**
         * Mark a storage object as expired.
		 * @param {string} namespace Namespace of object to expire.
		 * @param {string} key 		Key of object to expire.
         */
	    expire : function(namespace, key) {
            var item = this.get(namespace,key);
            manager.expire(item);
            return item;
        },
        /**
         * Remove object key from the given namespace and the cache without inspection.
         * @param  {string} namespace Namespace of targeted object.
         * @param  {[type]} key       Key of target object.
         */
        delete: function(namespace, key) {
            var nso = items[namespace];
            var item = this.get(namespace,key);
            if(nso){
                delete nso[key];
            }
            return item;
        },
	    /**
	     * Remove object key from the given namespace and the cache without inspection.
	     * @param  {string} namespace Namespace of targeted object.
	     * @param  {[type]} key       Key of target object.
	     */
	    clear: function(namespace) {
	        var nso = this.getAll(namespace);
            var ret = {};
            var key;
	        if(nso){
                for(key in nso){
                    ret[key] = nso[key];
    	            delete nso[key];
                    delete items[namespace][key];
                }
	        }
            return ret;
	    },
	    /**
	     * Remove the given namespace and it's objects from the cache without inspection.
	     * @param  {string} namespace Namespace to clear.
	     */
	    clearAll:function() {
            var nso=this.getAll();
            var key;
            for(key in items){
                delete items[key];
            }
	        return nso;
	    },
        /**
         * Remove the expired objects from the given namespace and the cache with inspection.
         * @param  {string} namespace Namespace to clear.
         * @return {object} Object composed of all of the removed elements.
         */
        clean : function(namespace){
            if(namespace !== UNDEF){ 
                return storageCleanup(this, namespace);
            }
            return {};
        },
        /**
         * Remove the expired objects from the all namespaces.
         * @param  {string} namespace Namespace to clear.
         * @return {object} Object composed of all of the removed elements.
         */
        cleanAll : function(){
            var key;
            var nso={};
            for(key in items){
                nso[key]=this.clean(key);
            }
            return nso;
        },

        errorCodes : errorCodes
	};
});